module.exports = __webpack_public_path__ + "img/Bingo_Info_Game1.d3114b0a.png";